/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryActivityLogListResponse } from './RevisdomAPIViewModelsEntryActivityLogListResponse';
import {
    RevisdomAPIViewModelsEntryActivityLogListResponseFromJSON,
    RevisdomAPIViewModelsEntryActivityLogListResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryActivityLogListResponseToJSON,
    RevisdomAPIViewModelsEntryActivityLogListResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryActivityLogListResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1ActivityLogListResponse
 */
export interface ApiResponse1ActivityLogListResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1ActivityLogListResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1ActivityLogListResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryActivityLogListResponse}
     * @memberof ApiResponse1ActivityLogListResponse
     */
    data?: RevisdomAPIViewModelsEntryActivityLogListResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1ActivityLogListResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1ActivityLogListResponse interface.
 */
export function instanceOfApiResponse1ActivityLogListResponse(value: object): value is ApiResponse1ActivityLogListResponse {
    return true;
}

export function ApiResponse1ActivityLogListResponseFromJSON(json: any): ApiResponse1ActivityLogListResponse {
    return ApiResponse1ActivityLogListResponseFromJSONTyped(json, false);
}

export function ApiResponse1ActivityLogListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1ActivityLogListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryActivityLogListResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1ActivityLogListResponseToJSON(json: any): ApiResponse1ActivityLogListResponse {
    return ApiResponse1ActivityLogListResponseToJSONTyped(json, false);
}

export function ApiResponse1ActivityLogListResponseToJSONTyped(value?: ApiResponse1ActivityLogListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryActivityLogListResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

